module.exports = __webpack_public_path__ + "static/media/checkboxInstall2purp.1a1da988.svg";